// extracted by mini-css-extract-plugin
export default {"header":"styles_header__f6J9x","list":"styles_list__tEDrH","singleTextCard":"styles_singleTextCard__gP4L3"};